export default "__VITE_ASSET__Dd99CX3j__"